export enum CarePlanSignatureStatusEnum {
    CompleteDescription = 'Complete',
    Complete = 1,
    IncompleteDescription = 'Incomplete',
    Incomplete = 2,
    PendingDescription = 'Pending',
    Pending = 3,
}
